import { LuCircleCheck } from 'react-icons/lu';
import './style.css';

const ProjectTasks = ({ data }) => {
  if (!data?.items?.length) return null;

  return (
    <section className="project-tasks project-case-card">
      <h2 className="project-case-card__title">{data.title}</h2>

      <ul className="project-tasks__list">
        {data.items.map((task) => (
          <li key={task} className="project-tasks__item">
            <LuCircleCheck />
            <span>{task}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectTasks;
